import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import IconSvg from '@/components/icon-component'
import VueAMap from 'vue-amap';
import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)

Vue.component('icon-svg', IconSvg)
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '自己申请的key值',
  //插件
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  //添加到这里,这里的render-event和vue.config.js里面的renderAfterDocumentEvent配置名称一致
  // mounted() {
  //   document.dispatchEvent(new Event('render-event'))
  // },
}).$mount('#app')
